import { render, staticRenderFns } from "./CourseInfoTable.vue?vue&type=template&id=133a7e18&"
import script from "./CourseInfoTable.vue?vue&type=script&lang=js&"
export * from "./CourseInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports